import * as React from 'react';
import { classes } from './ManuCloseIcon.st.css';
var ManuCloseIcon = function () {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: classes.ManuCloseIcon, "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 6.707L17.293 6L12 11.293L6.707 6L6 6.707L11.293 12L6 17.293L6.707 18L12 12.707L17.293 18L18 17.293L12.707 12L18 6.707Z" })));
};
export default ManuCloseIcon;
//# sourceMappingURL=ManuCloseIcon.js.map